import { nullable, record, string } from "superstruct";

export const CartSectionsSchema = record(string(), nullable(string()));
